<script setup>
import { computed } from 'vue';
const props = defineProps({ preview: { type: Object, required: true } });
const url = computed(() => {
  try {
    const parsed = new URL(props.preview.url);
    return ['https:', 'http:'].includes(parsed.protocol) &&
      !parsed.username &&
      !parsed.password
      ? parsed
      : null;
  } catch {
    return null;
  }
});
const thumbnail = computed(() => {
  const value = props.preview.thumbnail;
  return typeof value === 'string' &&
    value.length > 0 &&
    value.length <= 90000 &&
    /^[A-Za-z0-9+/]*={0,2}$/.test(value)
    ? `data:image/jpeg;base64,${value}`
    : null;
});
</script>

<template>
  <a
    v-if="url && preview.title"
    :href="url.href"
    target="_blank"
    rel="noopener noreferrer"
    class="flex w-full min-w-0 max-w-md overflow-hidden rounded-xl bg-n-alpha-2 text-inherit no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
    data-whatsapp-link-preview
  >
    <img
      v-if="thumbnail"
      :src="thumbnail"
      alt=""
      loading="lazy"
      class="h-24 w-24 shrink-0 object-cover"
    />
    <div class="grid min-w-0 gap-1 p-3">
      <strong class="line-clamp-2 break-words text-sm">{{
        preview.title
      }}</strong>
      <p
        v-if="preview.description"
        class="m-0 line-clamp-2 break-words text-xs opacity-90"
      >
        {{ preview.description }}
      </p>
      <span class="truncate text-xs" dir="ltr">{{ url.hostname }}</span>
    </div>
  </a>
</template>
